/* Curtain Creations: tidy text written in the Shopify page editor.
   Removes empty spacer lines, turns headings used as body text or table text into paragraphs,
   turns image-only tables and runs of images into responsive galleries, and fixes links
   that point at Shopify preview addresses. Runs once per .rte block inside the main content. */
(function () {
  var BLOCKS = 'p,h1,h2,h3,h4,h5,h6,div,blockquote';
  var MEDIA = 'img,iframe,video,table,svg,input,button,hr,picture,.cc-gallery,form';
  function txt(e) { return (e.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function swap(el, tag) {
    var n = document.createElement(tag);
    for (var i = 0; i < el.attributes.length; i++) n.setAttribute(el.attributes[i].name, el.attributes[i].value);
    while (el.firstChild) n.appendChild(el.firstChild);
    el.parentNode.replaceChild(n, el);
    return n;
  }
  function each(root, sel, fn) { Array.prototype.slice.call(root.querySelectorAll(sel)).forEach(fn); }
  function imageOnly(el) {
    if (el.tagName === 'IMG') return true;
    if (el.classList && el.classList.contains('cc-gallery')) return false;
    return /^(P|DIV|SPAN|A|FIGURE)$/.test(el.tagName) && !txt(el) && el.querySelector('img') && !el.querySelector('iframe,video,table');
  }
  function gallery(imgs, before) {
    var g = document.createElement('div');
    g.className = 'cc-gallery' + (imgs.length >= 3 ? ' many' : '');
    var n = imgs.length, cols = n === 4 ? 4 : Math.min(n, 3);
    g.style.setProperty('--cols', cols);
    g.style.setProperty('--cols-m', n === 3 ? 3 : (n >= 2 ? 2 : 1));
    if (n === 2) g.style.setProperty('--cols-m', 1);
    before.parentNode.insertBefore(g, before);
    imgs.forEach(function (i) {
      var link = i.parentNode && i.parentNode.tagName === 'A' ? i.parentNode : null;
      g.appendChild(link || i);
    });
    return g;
  }
  function clean(r) {
    if (r.getAttribute('data-cc-clean')) return;
    r.setAttribute('data-cc-clean', '1');

    // Links to Shopify preview/admin domains -> same path on this site
    each(r, 'a[href]', function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (/(shopifypreview\.com|myshopify\.com)$/.test(u.hostname)) a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
    each(r, 'meta,style,script', function (m) { m.remove(); });

    // Headings used inside tables, or as long body text, become paragraphs
    each(r, 'td h1,td h2,td h3,td h4,td h5,td h6,th h1,th h2,th h3,th h4,th h5,th h6', function (h) { swap(h, 'p'); });
    each(r, 'h5,h6', function (h) { if (txt(h).length > 50) swap(h, 'p'); });
    each(r, 'h1,h2,h3,h4', function (h) { if (!txt(h) && h.querySelector('img')) swap(h, 'p'); });

    // Tables
    each(r, 'table', function (t) {
      var cells = Array.prototype.slice.call(t.querySelectorAll('td,th'));
      var imgs = Array.prototype.slice.call(t.querySelectorAll('img'));
      if (cells.length && imgs.length && cells.every(function (c) { return !txt(c); })) {
        gallery(imgs, t); t.remove(); return;
      }
      [t].concat(Array.prototype.slice.call(t.querySelectorAll('tbody,thead,tr,td,th'))).forEach(function (e) {
        e.removeAttribute('width'); e.removeAttribute('height'); e.style.width = ''; e.style.height = '';
      });
      if (cells.length === 1) {
        var d = document.createElement('div'); d.className = 'cc-callout';
        while (cells[0].firstChild) d.appendChild(cells[0].firstChild);
        t.parentNode.replaceChild(d, t); return;
      }
      var w = document.createElement('div'); w.className = 'cc-table-wrap';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });

    // Remove empty spacer blocks and empty inline wrappers (repeat until stable)
    var changed = true, guard = 0;
    while (changed && guard++ < 6) {
      changed = false;
      each(r, BLOCKS, function (e) {
        if (!e.isConnected) return;
        if (e.classList.contains('cc-gallery') || e.classList.contains('cc-table-wrap') || e.classList.contains('cc-callout')) return;
        if (!txt(e) && !e.querySelector(MEDIA)) { e.remove(); changed = true; }
      });
      each(r, 'span,strong,b,em,i,u', function (e) {
        if (e.isConnected && e.textContent === '' && !e.querySelector(MEDIA)) { e.remove(); changed = true; }
      });
    }
    // Line breaks used as spacers
    Array.prototype.slice.call(r.children).forEach(function (c) { if (c.tagName === 'BR') c.remove(); });
    each(r, 'p,h1,h2,h3,h4,h5,h6,td,div', function (e) {
      while (e.firstChild && (e.firstChild.nodeName === 'BR' || (e.firstChild.nodeType === 3 && !e.firstChild.textContent.replace(/ /g, ' ').trim() && e.firstChild.nextSibling && e.firstChild.nextSibling.nodeName === 'BR'))) e.firstChild.remove();
      while (e.lastChild && (e.lastChild.nodeName === 'BR' || (e.lastChild.nodeType === 3 && !e.lastChild.textContent.replace(/ /g, ' ').trim()))) e.lastChild.remove();
    });

    // Short bold-only paragraphs in capitals or ending with ':' read as subheadings
    each(r, 'p', function (p) {
      var t = txt(p);
      if (!t || t.length > 90 || p.querySelector('img,a')) return;
      var bold = Array.prototype.slice.call(p.querySelectorAll('b,strong')).map(txt).join(' ');
      if (bold.replace(/\s/g, '') === t.replace(/\s/g, '') && (t === t.toUpperCase() || /:$/.test(t))) p.classList.add('cc-subhead');
    });

    // Runs of two or more image-only blocks become a gallery
    var kids = Array.prototype.slice.call(r.children), run = [];
    function flush() {
      var imgs = [];
      run.forEach(function (el) { if (el.tagName === 'IMG') imgs.push(el); else imgs = imgs.concat(Array.prototype.slice.call(el.querySelectorAll('img'))); });
      if (imgs.length >= 2) { var g = gallery(imgs, run[0]); run.forEach(function (el) { if (el.isConnected && el !== g && !el.querySelector('img') && el.tagName !== 'IMG') el.remove(); }); }
      run = [];
    }
    kids.forEach(function (k) { if (imageOnly(k)) run.push(k); else flush(); });
    flush();

    // Images: lazy-load and drop sizes set in the editor
    each(r, 'img', function (i) { if (!i.getAttribute('loading')) i.setAttribute('loading', 'lazy'); i.style.width = ''; i.style.height = ''; i.style.marginBottom = ''; });
  }
  function run() { each(document, '#MainContent .rte', clean); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
